require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./projecten-versterk-de-scheldekust.json") })
        }
      }, "path---projecten-versterk-de-scheldekust");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---projecten-versterk-de-scheldekust!./.cache/json/projecten-versterk-de-scheldekust.json
// module id = 453
// module chunks = 231608221292675